import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Email from "@mui/icons-material/Email";

interface EmailInputProps {
  email: string;
  onChange: (value: string) => void;
  show: boolean;
}

export default function EmailInput({ email, onChange, show }: EmailInputProps) {
  if (!show) return null;

  return (
    <TextField
      fullWidth
      label="Email"
      type="email"
      value={email}
      onChange={(e) => onChange(e.target.value)}
      required
      autoComplete="email"
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: 3,
        },
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Email sx={{ color: "primary.main" }} />
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
